// extracted by mini-css-extract-plugin
export var link = "standardLink-module--link--5l37t";